import store from "@/config/vuex/store";

export default [
    {
        path: "/seguimentos",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "seguimentosRead",
                component: () => import('@/pages/Seguimento/SeguimentoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "cadastrar",
                name: "seguimentosCreate",
                component: () => import('@/pages/Seguimento/SeguimentoCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "seguimentosUpdate",
                component: () => import('@/pages/Seguimento/SeguimentoUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

